export default __webpack_public_path__ + "img/38a7ddf1402fb3d05329ce219e816f33.svg";